import { Component, OnInit, Inject } from '@angular/core';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Smsbitacora } from 'app/entities/smsbitacora';
import { ServiciosService } from 'app/services/servicios.service';
import { SmsService } from 'app/services/sms/sms.service';
import { Categoria } from 'app/entities/categoria';

@Component({
  selector: 'app-sms-programar-cobro',
  templateUrl: './sms-programar-cobro.component.html',
  styleUrls: ['./sms-programar-cobro.component.scss']
})
export class SmsProgramarCobroComponent implements OnInit {

  public descripcion;/* descripcion del mensaje */
  public mensajes; /* mensaje que se le va a enviar al usuario */
  public numero; /* celular al cual se le va a enviar el mensaje de texto */
  public agregarnum; /* habilita el campo editar celular */
  public telefono; /* numero de telefono fijo (a veces el numero de celular esta en este campo) */
  public nuevonum; /* nuevo numero que se le va a asignar a ese radicado  */
  public radicado; /* radicado de gurpos_afi (grugru) */
  public expreg; /* expresion regular que valida si es un numero celular */
  public descripcion2;
  public form: Smsbitacora = new Smsbitacora();
  public datosUsuario = JSON.parse(localStorage.getItem('usuario'));
  public estado_sms: boolean;
  public empresa:any;
  public infoGrupo:{
    estado_sms: any,
    grunit: string,
    estadoMascotas:number,
    estadoRMV: number
  }
  public categorias:Array<Categoria>;
  public categoria:string;
  constructor(  private service: CarteraService,
                private servicios:ServiciosService,
                @Inject(MAT_DIALOG_DATA) private datos,
                private _sms:SmsService,
                private snack:MatSnackBar
            ) {
    this.estadoSMSGrupo(datos.radicado,datos.empresa);
  }

  ngOnInit() {
    console.log(this.datos)
    if(this.datos.empresa==="medisoft"){
      this.datos.empresa = "RMV"
    }else{
      this.datos.empresa="VM"
    }
    /* se asignan las variable que llegan inyectadas del MAT_DIALOG_DATA */
    this.radicado = this.datos.radicado
    this.telefono = this.datos.telefono;
    this.numero = this.datos.numero;

    this.agregarnum = false;
    this.categorias = [];
  }
  /* esta funcion habilita el campo editar celular */
  agregarnumero(){
    this.agregarnum = true;
  }
  /* esta funcion se encarga de mandar el mensaje de texto. recibe el numero y el mensaje,
     y la envia al servicio que se encarga de mandar el mensaje */
  enviarSMS() {

    this.expreg = new RegExp('^3[0-9]{9}$');
    let validate = this.expreg.test(this.nuevonum);

    /* se valida si el numero de celular es correcto y se envia el mensaje de lo contrario muestra un mensaje de error */
    if (this.numero) {
        this.service.enviarsms(this.numero, this.descripcion.mensaje1).subscribe((data: any) => {
          if (data.resultado == 0) {
            this.snack.open('Se envio el mensaje con exito', '', {
              duration: 2200,
              panelClass: 'blue-bg'
            })
            this.form = {
              TipoSMS: 1,
              Id_MensajePredefinido: this.descripcion.Id_sms,
              MensajeLibre: '',
              numeroCel: this.numero,
              ID_beneficiario: null,
              ID_Titular: null,
              ID_grupo: this.datos.grupo,
              Id_UsuarioQenviaSMS: this.datosUsuario.id_usuario,
              Area: this.descripcion.Area,
              Dependencia: this.descripcion.dependencia,
              Estado: 0,
              Numfactura: this.datos.factura,
              NumCSC: null
            }/* este objeto y esta funcion se encargan de insertar los datos en la bitacora de sms */
            this.servicios.bitacorasms(this.form).subscribe(succ=>succ)

          } else {
            this.snack.open('Error al enviar el mensaje', '', {
              duration: 2200,
              panelClass: 'warn-bg'
            })
          }
        });

      
    } else if (this.nuevonum && validate == true) {
        this.numero = this.nuevonum;
        this.service.enviarsms(this.numero, this.descripcion).subscribe((data: any) => {
          if (data.resultado == 0) {
            this.snack.open('Se envio el mensaje con exito', '', {
              duration: 2200,
              panelClass: 'blue-bg'
            })
            this.form = {
              TipoSMS: 1,
              Id_MensajePredefinido: this.descripcion.Id_sms,
              MensajeLibre: '',
              numeroCel: this.datos.numero,
              ID_beneficiario: this.datos.beneficiario,
              ID_Titular: this.datos.titular,
              ID_grupo: this.datos.grupo,
              Id_UsuarioQenviaSMS: this.datos.usuario,
              Area: this.descripcion.Area,
              Dependencia: this.descripcion.dependencia,
              Estado: 0,
              Numfactura: null,
              NumCSC: this.datos.csc
            }/* este objeto y esta funcion se encargan de insertar los datos en la bitacora de sms */
            
            this.servicios.bitacorasms(this.form).subscribe(succ=>succ)
          } else {
            this.snack.open('Error al enviar el mensaje', '', {
              duration: 2200,
              panelClass: 'warn-bg'
            })
          }
        });
    } else if (!this.numero){
        this.snack.open('Ingrese un número celular', '', {
          duration: 2500,
          panelClass: 'blue-400'
        });
    }
  }

  /* esta funcion es la encargada de editar el celular del grupo,
      se le envia el nuevo numero y el radicado al  cual se le va a editar el numero */
  nuevocel(){

    this.expreg = new RegExp('^3[0-9]{9}$');

    if (this.expreg.test(this.nuevonum)) {
        this.service.editargurcel(this.nuevonum,this.radicado).subscribe((data)=>{
          this.numero = this.nuevonum;
        });
    } else {
        this.snack.open('Ingrese correctamente en número celular','',{
          duration:2500,
          panelClass:'warn-700'
        })
    }
  }

  onValueChange() {
    this.descripcion2 = this.descripcion.mensaje1;
  }
  estadoSMSGrupo(grugru: string,empresa:string){
    if(empresa=='Red Medica Vital'){
      empresa = 'RMV'
    }else if(empresa == "Vital Mascotas"){
      empresa = 'VM'
    }
    this.service.VerEstadoSMSGrupo(grugru,empresa)
                .subscribe((data: {estado_sms: any,grunit: string,estadoMascotas: number,estadoRMV: number}) => {
                  this.estado_sms = data.estado_sms === 0 ? false : true
                  this.infoGrupo = data;
                });
  }

  updateEstadoSMS(estado: boolean){
    const nuevo_estado: number = estado === true ? 0 : 1;
    this.service.ActualizarEstadoSMS(this.datos.radicado, nuevo_estado).subscribe((data: any) => {
      if(data.changedRows === 1){
        this.estadoSMSGrupo(this.datos.radicado,this.datos.empresa);
      }
    });
  }

  buscarCategoriasByEmpresa(){
    console.log(this.empresa);
    this._sms.categoriasDeUnaEmpresa({empresa:this.empresa}).subscribe(succ=>this.categorias = succ);
  }

  /* servicio que trae la informacion de los mensajes de texto */
  buscarMensajesByEmpresaAndCategory(){
    this._sms.mensajesDeUnaEmpresaPorCategorias({empresa:this.empresa,categoria:this.categoria}).subscribe(succ=>this.mensajes = succ); 
   }
}